const Footer = () => {
  return (
    <div className="text-sm sm:text-base text-center py-4 bg-gray-950 border-cyan-100 border-t-4 text-white mt-auto">
        Developed with <span style={{color: "#CE2029"}}>&hearts;</span> by Utkarsh
    </div>
  );
};

export default Footer;